
import ShareResultButtonComponent from '@/components/ViewResultCard/ShareResultButton/ShareResultButtonComponent';
export default ShareResultButtonComponent;
